import { Map } from 'immutable';

export function requestRowAdapter(json) {
  return Map(json);
}
